import styled from '@emotion/styled';
import React, { useRef, useState } from 'react';
import { mergeProps, useTextField } from 'react-aria';
import TextareaAutosize from 'react-textarea-autosize';

import { mergeRefs } from '../../../lib/mergeRefs';

import { useI18n } from '../../../hooks/useI18nFormatters';

import { su } from '../../../theme/functions/su';
import { input } from '../../../theme/Global';
import { theme } from '../../../theme/theme';

export const DeviceSettingsNote = React.forwardRef((props, ref) => {
  const { i18n } = useI18n();
  const [value, setValue] = useState(props.note);
  const textFieldRef = useRef();

  const { ref: registerRef, ...registerProps } =
    props.register?.('note', {
      required: props.required,
      minLength: props.minLength,
      pattern: props.pattern ? new RegExp(props.pattern) : undefined,
    }) ?? {};

  const textField = useTextField(
    {
      'aria-label': 'Device note',
      id: 'note',
      name: 'note',
      inputElementType: 'textarea',
      inputMode: 'none',
      defaultValue: value,
      placeholder: i18n.messageFormatter('device.settings.note'),
      ...props,
      onChange: (value) => setValue(value),
    },
    textFieldRef,
  );

  return (
    <S.Root>
      <S.TextareaAutosize
        {...mergeProps(textField.inputProps, registerProps)}
        ref={mergeRefs([textFieldRef, registerRef, ref])}
        minRows={3}
      />
    </S.Root>
  );
});

function S() {}
DeviceSettingsNote.S = S;

S.Root = styled.div`
  margin-top: ${su(2)};
  padding-top: ${su(2)};
  border-top: 1px solid ${theme.color.line};
`;

S.TextareaAutosize = styled(TextareaAutosize)`
  ${input}
  width: 100%;
  resize: none;
  padding: 8px;

  &::placeholder {
    color: ${theme.color.mono_300};
  }
`;
